// extracted by mini-css-extract-plugin
module.exports = {"moduleItem":"moduleItem--1X8Yq","white":"white--eKX4s","grey":"grey--2Cssw","title":"title--uAbpt"};